import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { I18n } from 'react-redux-i18n'
import moment from 'moment'

import ChatChannelWallMessage from './ChatChannelWallMessage'
import ScrollableContent from '../../ScrollableContent'
import { DeferredMessage } from '../ChatChannels/ChatChannelMessage'
import ChatChannelPost from '../ChatChannels/ChatChannelPost'
import { deleteDeferred } from '../../../redux/actions/conversations/messagesAct'
import settingsActions from 'redux/settings/actions'

const POST_CHANNEL = ['instagram_post', 'facebook_post', 'wall']

class ChatChannelWallMessages extends React.Component {
  constructor(props) {
    super(props)
    this.isLoadedMessages = false
    this.messagesAct = bindActionCreators({ deleteDeferred }, props.dispatch)
    this.settingsActions = bindActionCreators(settingsActions, props.dispatch)
    this.state = {
      wallMessages: [],
      loading: true
    }
  }

  componentDidMount() {
    const {
      settings: { msgFilterEvent }
    } = this.props

    this.props.getWall({ userId: this.props.user._id, eventType: msgFilterEvent })
      .then(() => {
        this.isLoadedMessages = true
        this.setState(state => ({ ...state, loading: false }))
      })
      .catch(console.error)
  }

  componentDidUpdate(prevProps) {
    const {
      settings: { msgFilterEvent: oldMsgFilterEvent },
      wall: oldWall
    } = prevProps
    const {
      settings: { msgFilterEvent },
      wall,
      chat: { drafts },
    } = this.props

    if (oldMsgFilterEvent !== msgFilterEvent) {
      this.props.getWall({ userId: this.props.user._id, eventType: msgFilterEvent  })
        .then(() => {
          this.isLoadedMessages = true
          this.setState(state => ({ ...state, loading: false }))
        })
        .catch(console.error)
    }

    if (oldWall !== wall) {
      this.setState(state => ({
        ...state,
        wallMessages: this.getAllMessages({ messages: { ...wall.data, drafts } })
      }))
    }
  }

  getAllMessages({ messages }) {
    const newMessages = []
    messages.nodeInfos && messages.nodeInfos.forEach(nodeInfo => newMessages.push({
      ...nodeInfo,
      messageType: 'normal'
    }))

    const newDrafts = []
    messages.drafts && messages.drafts.forEach(draft => newDrafts.push({
      ...draft,
      messageType: 'draft'
    }))

    const combinedMessages = [...newMessages, ...newDrafts]
    return combinedMessages.sort((dateA, dateB) => moment(dateB.createdAt) - moment(dateA.createdAt))
  }

  checkDeferredMessage(channel, deferredMessages, typeView) {
    if (!deferredMessages.shouldShow) return false
    if (typeView === 'chat') return true
    if (!POST_CHANNEL.includes(channel)) return true

    return false
  }

  checkWallChat(channel, typeView) {
    if (typeView === 'chat') return true
    if (!POST_CHANNEL.includes(channel)) return true

    return false
  }

  checkWallPost(channel, typeView) {
    if (typeView === 'chat') return false
    if (POST_CHANNEL.includes(channel)) return true

    return false
  }

  render() {
    const {
      settings: { msgFilterEvent, messageIdToGo },
      chat: { deferredMessages },
      user,
      wall,
      operator,
      labels,
      activitiesTypes,
      toggleDeleteDraftModal,
      handleEditDraft,
      handleToggleShowHideDraft
    } = this.props

    const channel = user.channels[0].channel
    const typeView = wall?.data?.typeView

    const hasDeferredMessage = this.checkDeferredMessage(channel, deferredMessages, typeView)
    const isWallChat = this.checkWallChat(channel, typeView)
    const isWallPost = this.checkWallPost(channel, typeView)

    const allMessages = [...this.state.wallMessages, ...deferredMessages.messages]

    return (
      <div className='messages-container'>
        <ScrollableContent goToTop goToId={messageIdToGo}>
          <div className={`messages`}>
            {
              hasDeferredMessage ? (
                deferredMessages.messages.map((msg, index) => (
                  <DeferredMessage
                    key={`${index}-${user.id}-${msg.status}-${msg.scheduledAt}`}
                    user={{ name: user.name }}
                    content={msg}
                    deleteDeferred={(deferredId) => this.messagesAct.deleteDeferred(deferredId)}
                  />
                ))
              ) : null
            }

            {isWallChat && !this.state.loading && (
              <ChatChannelWallMessage
                wallMessages={this.state.wallMessages}
                user={user}
                operator={operator}
                isChat={isWallChat}
                activitiesTypes={activitiesTypes}
                toggleDeleteDraftModal={toggleDeleteDraftModal}
                handleEditDraft={handleEditDraft}
                handleToggleShowHideDraft={handleToggleShowHideDraft}
              />
            )}

            {isWallPost && this.state.wallMessages.map(comment => (
              <ChatChannelPost
                key={comment._id}
                comment={comment}
                operator={operator}
                activitiesTypes={activitiesTypes}
                labels={labels}
              />
            ))}

            {wall.isFetchingWalls && (
              <p className='messages__info'>{`${I18n.t('dashboard_loading-messages')}...`}</p>
            )}

            {(!wall.isFetchingWalls && allMessages.length <= 0) ? (
              ['messages', 'activities'].includes(msgFilterEvent) ? (
                <p className='messages__info'>{I18n.t('dashboard_conversations_noResultsFilter')}</p>
              ) : (
                <p className='messages__info'>{I18n.t('dashboard_no-messages')}</p>
              )
            ) : null}

            {(!wall.isFetchingWalls && allMessages[allMessages.length - 1]?.firstMessage) ? (
              <p className='messages__info'>{I18n.t('dashboard_no-more-messages')}</p>
            ) : null}
          </div>
        </ScrollableContent>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  wall: state.wall,
  settings: state.settings,
  poolLists: state.poolLists,
  operator: state.user
})

export default connect(mapStateToProps)(ChatChannelWallMessages)
